export const buildIValueLabelPairFromValue = (value: GQL.IAttributeValue, language: string, subOption: string, attribute: any) => {
    const attributeTypeKey = attribute.definition && attribute.definition[0] && attribute.definition[0].value;
    if (typeof value.value[language] === 'object') {
        if (subOption == undefined || subOption == '') {
            const keys = Object.keys(value.value[language]);
            return {
                label: value.value[language][attributeTypeKey || keys[0]],
                value: value.id
            };
        } else {
            return {
                label: value.value[language][subOption],
                value: value.id
            };
        }
    } else {
        return {
            label: (value.value[language] ? value.value[language] : value.title),
            value: value.id
        };
    }
};



// WEBPACK FOOTER //
// ./src/helpers/attributes/buildIValueLabelPairFromValue.ts